<template>
  <section id="main-content">
    <section class="wrapper">
      <section class="login container-fluid">
        <div class="container box-login">
          <div class="row">
            <div class="col-12 col-md-6 text-center">
              <h1>Redefinir a Senha</h1>
            </div>
            <div class="col-12 col-md-6 col-form">
              <form method="POST" v-on:submit.prevent="redefinirSenha()" class="form-login mt-4">
                <form-group id="emailCadastro" label="E-mail" label-class="sr-only" :text="{ required: 'Obrigatório informar o e-mail', email: 'E-mail inválido' }" :field="$v.email">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text text-center"><i class="far fa-envelope"></i></div>
                    </div>
                    <input id="emailCadastro" type="email" class="form-control" name="email" placeholder="E-mail" v-model="email">
                  </div>
                </form-group>

                <form-group id="senhaCadastro" label="Senha" label-class="sr-only" :text="{ required: 'Obrigatório informar a senha' }" :field="$v.senha">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text text-center"><i class="fas fa-unlock-alt"></i></div>
                    </div>
                    <input id="password" type="password" class="form-control" placeholder="Senha" v-model="senha">
                  </div>
                </form-group>

                <form-group id="repetirSenhaCadastro" label="Repetir senha" label-class="sr-only" :text="{ required: 'Obrigatório informar a repetição da senha', confirmacaoSenha: 'A senha e a confirmação devem ser iguais.' }" :field="$v.repeticaoSenha">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text text-center"><i class="fas fa-unlock-alt"></i></div>
                    </div>
                    <input id="repetirSenhaCadastro" type="password" class="form-control" placeholder="Repetir senha" v-model="repeticaoSenha">
                  </div>
                </form-group>

                <button type="submit" id="resetSenha" class="btn btn-primary mb-2" :disabled="submit">
                  <i class="fas fa-spinner fa-spin" v-if="submit"></i>
                  <template v-else>Redefinir a senha</template>
                </button>

                <p><a @click="$router.push('/login')" href="javascript:void(0)">Voltar para o login</a></p>
              </form>
            </div>
          </div>
        </div>
      </section>

    </section>
  </section>
</template>

<script>
import FormGroup from '@/core/components/FormGroup'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import UsuarioAPI from '@/api/usuario-api'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/utils/response-utils'

export default {
  name: 'RedefinicaoSenhaView',
  components: { FormGroup },

  data () {
    return {
      submit: false,
      email: '',
      senha: '',
      token: null,
      repeticaoSenha: '',
      primeiroAcesso: false
    }
  },

  validations: {
    email: { required, email },
    senha: { required },
    repeticaoSenha: { required, confirmacaoSenha: sameAs('senha') }
  },

  computed: {
    isPrimeiroAcesso () {
      return this.primeiroAcesso
    }
  },

  created () {
    document.body.classList.add('login')
  },

  destroyed () {
    document.body.classList.remove('login')
  },

  mounted () {
    if (this.$route.name === 'primeiro-acesso-redefinir-senha') {
      this.primeiroAcesso = true
    }

    this.token = this.$route.params.token
  },

  methods: {
    redefinirSenha: function () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.submit = true

        this.$v.$reset()

        UsuarioAPI.redefinirSenha(this.email, this.senha, this.token, process.env.VUE_APP_EMPRESA_REF)
          .then(data => {
            if (data.status) {
              Swal.fire({ icon: 'success', text: 'Sua senha foi redefinida com sucesso!' })
                .then(() => {
                  window.location = '/login'
                })
            } else {
              const mensagem = Object.keys(data).reduce((result, value) => result + ' ' + data[value], '').trim()
              Swal.fire({ icon: 'error', text: mensagem })
            }
          }).catch(error => ResponseUtils.handleError(error))
          .then(() => {
            this.submit = false
          })
      }
    }
  }
}
</script>

<style scoped>

</style>
